import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-sellado',
  templateUrl: './btn-nuevo-tipo-sellado.component.html',
  styleUrls: ['./btn-nuevo-tipo-sellado.component.css']
})
export class BtnNuevoTipoSelladoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
